import type { BBox, GeoPoint } from './common.ts';

/**
 * Une commune couverte par le service. Ne contient AUCUN identifiant propre à un fournisseur :
 * ceux-ci vivent dans worker/cities/<slug>.ts.
 */
export interface City {
  readonly slug: string;
  readonly name: string;
  /** Code officiel géographique INSEE. */
  readonly inseeCode: string;
  readonly postalCodes: readonly string[];
  readonly department: { readonly code: string; readonly name: string };
  readonly region: string;
  readonly country: 'FR';
  readonly timeZone: string;
  readonly center: GeoPoint;
  readonly bbox: BBox;
}

/** Libellé géographique complet, utilisé pour le SEO et les textes : on ne suppose jamais que « Ermont » suffit. */
export function cityFullLabel(city: City): string {
  return `${city.name} (${city.department.name}, ${city.department.code}), ${city.region}, France`;
}

/** « d'Ermont » / « de Sannois » : élision devant voyelle ou h muet (approximation suffisante pour les noms de communes). */
export function ofCity(city: Pick<City, 'name'>): string {
  return /^[aeiouyàâäéèêëîïôöùûüh]/i.test(city.name) ? `d'${city.name}` : `de ${city.name}`;
}
